import React, { useEffect, useRef, useState } from 'react'
import HeaderComponent from '../components/HeaderComponent'
import { Link } from '@reach/router'
import { useAuth } from '../providers/AuthContext'
import { LoadingPage } from '../components/PageLoading'
import { set } from 'lodash'
export const DicomUploaderPage = ({ instanceData }) => {

  const title = instanceData?.title || 'Purview Image'
  const [isLoading, setIsLoading] = useState(true)
  const [authUploadToken, setAuthUploadToken] = useState()
  useEffect(() => {
    document.title = title
  }, [title])

  // get url param named auth and pass it into the iframeUrl
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const auth = urlParams.get("auth")
    if (auth) {
      setAuthUploadToken(auth)
      setIsLoading(false)
    }
  }, [])

  if (!(authUploadToken) && isLoading) {
    return <><LoadingPage /></>
  }

  return <div style={{height: '100%', minHeight: '100%', display: 'flex', flexDirection: 'column'}}>
    {/* <HeaderComponent /> */}
    {/* <ifram */}
    {/* <Link to="/activity-logs/?studyDesc=TESTROUTEALFEU&studyUid=2.25.950214319919039275127642223799071945">Check activity logs</Link> */}
    <iframe src={`/wl/dicomuploader?auth=${authUploadToken}`}  sandbox="allow-downloads allow-scripts allow-same-origin allow-popups allow-top-navigation allow-top-navigation-by-user-activation allow-forms" width={'100%'}  title={title} style={{border: '0px', margin: '0px', padding: '0px', height: '100%'}}></iframe>

  </div>
}